export interface GlobNavbarHeader {
  links: {
    home: string;
    moreParts: string;
    beAdvertiser: string;
    beBuyer: string;
  };
  login: string;
  logout: string;
  subscriberPanel: string;
}

export interface ICoreNavbarTop {
  about: string;
  contact: string;
  faq: string;
};
export interface ICoreStrings {
  core: {
    navbarTop: ICoreNavbarTop;
    navbarHeader: GlobNavbarHeader;
    navbarFooter: {
      title: string;
      description: string;
      about: {
        title: string;
        description: string;
      };
    };
  }
  autoParts: {
    national: string;
    imported: string;
    priceFrom: string;
  };
  mostViewed: {
    title: string;
  };
  mostRecent: {
    title: string;
  };
  filter: {
    groups: {
      manufacturer: string;
      year: string;
    };
  };
  products: {
    moreInformations: string;
    shippingDescription: string;
    buttonText: string;
    shippingDetails: (advertiserName: string) => string;
    informationTitle: string;
  };
  authPage: {
    policy: (termsUrl: string, privacyUrl: string) => string;
    signUp: {
      steps: {
        [key: number]: string;
      };
      step1: {
        title: string;
      };
      step2: {
        label: string;
        placeholder: string;
      };
      step3: {
        label: string;
      };
      button_continue: string;
      button_back: string;
      button_done: string;
      phoneValidation: {
        phoneInvalidTitle: string;
        phoneInvalidDescription: string;
      };
    };
  };
  subscription: {
    description: string;
  };
  dashboard: {
    empty_content: string;
    auto_part: {
      create: {
        title: string;
        subtitle_one: string;
        subtitle_two: string;
        subtitle_three: string;
        form: {
          part_name: {
            label: string;
            placeholder: string;
          };
          manufacturer: {
            placeholder: string;
          };
          price: {
            placeholder: string;
          };
          brand: {
            placeholder: string;
          };
          model: {
            placeholder: string;
            national: string;
          };
          quantity: {
            placeholder: string;
          };
          description: {
            placeholder: string;
          };
          isNew: string;
          image: {
            label: string;
          };
          buttonCancel: string;
          buttonSubmit: string;
        };
        updated: string;
        created: string;
      };
      list: {
        title: string;
        deleted: string;
      };
    };
  };
}

export const CoreStrings: {
  PTBR: ICoreStrings
} = {
  PTBR: {
    core: {
      navbarTop: {
        about: "sobre nós",
        contact: "fale conosco",
        faq: "dúvidas",
      },
      navbarHeader: {
        links: {
          home: "início",
          moreParts: "mais peças",
          beAdvertiser: "quero anunciar",
          beBuyer: "quero comprar",
        },
        login: "Entrar",
        logout: "Sair",
        subscriberPanel: "Painel do Assinante"
      },
      navbarFooter: {
        title: "NÃO ENCONTROU O QUE PROCURA?",
        description:
          "Cadastre-se para ser notificado quando houver uma peça disponível",
        about: {
          title: "Sobre Nós",
          description: `O site ${process.env.REACT_APP_NAME} não realiza e também não intermedia a venda de peças, nós apenas permitimos que os proprietários anunciem sob sua responsabilidade.`,
        },
      },
    },
    autoParts: {
      national: "PEÇAS DE NACIONAIS",
      imported: "PEÇAS DE IMPORTADOS",
      priceFrom: "A partir de R$ ",
    },
    mostViewed: {
      title: "peças mais vistas",
    },
    mostRecent: {
      title: "peças +recentes",
    },
    filter: {
      groups: {
        manufacturer: "fabricante",
        year: "ano",
      },
    },
    products: {
      moreInformations: "+informações do produto",
      shippingDescription: "O frete é combinado diretamente com o anunciante",
      buttonText: "Tenho Interesse",
      shippingDetails: (advertiserName) =>
        `Este produto é anunciado, fornecido e enviado por ${advertiserName} que garante sua compra do pedido à entrega.`,
      informationTitle: "Informações do Produto",
    },
    authPage: {
      policy: (termsUrl, privacyUrl) =>
        `Ao continuar, você concorda e aceita nossos {${termsUrl},Termos de Uso} e {${privacyUrl},Políticas de Privacidade}.`,
      signUp: {
        steps: {
          0: "Olá",
          1: "Contato",
          2: "Validação",
        },
        step1: {
          title:
            "Para sua segurança nós utilizamos sua conta na Google para te identificar. Por favor entre com seu login",
        },
        step2: {
          label: "Informe seu número de telefone celular",
          placeholder: "(99) 9-8765-4321",
        },
        step3: {
          label:
            "Enviamos um código de verificação para seu celular, confirme-o digitando abaixo:",
        },
        button_continue: "Continuar",
        button_back: "Voltar",
        button_done: "Validar",
        phoneValidation: {
          phoneInvalidTitle: "Código de Verificação Incorreto",
          phoneInvalidDescription:
            "Este código não corresponde ao código enviado. Tente novamente.",
        },
      },
    },
    subscription: {
      description: `Assinando qualquer um dos planos, você poderá anunciar mais peças e ter maior visibilidade no site ${process.env.REACT_APP_NAME}.<br />Ao fazer um anúncio, nós nos encarregaremos de notificá-lo assim que um usuário demonstrar interesse na peça anunciada.`,
    },
    dashboard: {
      empty_content: "Uops, nada por aqui!",
      auto_part: {
        create: {
          title: "Produtos",
          subtitle_one: "Sobre o Produto",
          subtitle_two: "Compatibilidade",
          subtitle_three: "Imagens",
          form: {
            part_name: {
              label: "Nome da Peça",
              placeholder: "Digite o nome da peça",
            },
            manufacturer: {
              placeholder: "Fabricante da Peça",
            },
            price: {
              placeholder: "Valor da Peça",
            },
            brand: {
              placeholder: "Marca",
            },
            model: {
              placeholder: "Modelo",
              national: "Este é um modelo de carro nacional",
            },
            quantity: {
              placeholder: "Estoque de peças idênticas",
            },
            description: {
              placeholder: "Digite informações sobre a peça",
            },
            isNew: "Novo",
            image: {
              label: "Escolha imagens (JPG, PNG, JFIF, WEBP)",
            },
            buttonCancel: "Cancelar",
            buttonSubmit: "Gravar",
          },
          updated: "Produto atualizado com sucesso!",
          created: "Produto cadastrado com sucesso!",
        },
        list: {
          title: "Produtos",
          deleted: "Produto removido com sucesso!",
        },
      },
    },
  },
};
